
import { Vue, Component, Prop } from 'vue-property-decorator';
import { getMarkerStyle } from '@/features/common/helpers';

export interface LabelItemType {
  qty: number,
  name: string
}

@Component
export default class LabelsList extends Vue {
  @Prop({ required: true }) items!: Array<LabelItemType>;

  @Prop({ required: false, default: true }) isPercentage!: boolean;

  @Prop({ default: ['#623ec7', '#cb0f51', '#ffa43c', '#2bc5cb'] }) colors!: Array<string>;

  @Prop({ default: false }) icon!: boolean;

  @Prop({ required: true }) widget!: string;

  @Prop({ required: false, default: true }) isRedirect!: boolean;

  private getMarkerStyle = getMarkerStyle;
}
